import React from 'react';
import { Platform, StyleSheet, View, type ViewProps } from 'react-native';

import { theme, useResponsive } from '@sg/garnish';

// ────────────────────────────────────────────────────────────────────────────

export const BagCheckoutContainer = (props: ViewProps) => {
  const { minWidth } = useResponsive();

  return (
    <View style={[styles.container, minWidth.isSM && styles.containerSM]} {...props}>
      {props.children}
    </View>
  );
};

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: Platform.select({ default: theme.spacing['4'], ios: 2 }),
  },
  containerSM: {
    paddingBottom: theme.spacing['6'],
  },
});
